<template>
    <div class="customer-reviews slider">
        <h2 class="text-center">Kundenbewertungen</h2>

        <loader text="Lade Bewertungen ..." v-if="loading"></loader>

        <swiper :options="swiperOptions" ref="mySwiper" v-else :class="'px-3'">
            <swiper-slide v-for="rating in ratings" :key="rating.UID" >
                <customer-review :review="rating"></customer-review>
            </swiper-slide>

            <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
            <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
        </swiper>
    </div>
</template>

<script>
    import 'swiper/dist/css/swiper.css';

    import {swiper, swiperSlide} from 'vue-awesome-swiper';

    export default {
        name: "CustomerReviews",
        props: {
            trustedShopsId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                loading: true,
                ratings: [],
                swiperOptions: {
                    watchOverflow: true,
                    touchRatio: 0,
                    centeredSlides: true,
                    initialSlide: 1,
                    slideToClickedSlide: true,
                    slideOffsetBefore: 60,
                    slideOffsetAfter: 60,
                    loop: true,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    noSwiping: false,
                    breakpoints: {
                        // when window width is >= 320px
                        576: {
                            slidesPerView: 1,
                            spaceBetween: 30,
                            slideOffsetBefore: 0,
                            slideOffsetAfter: 0,
                            noSwiping: false
                        },
                        // when window width is >= 480px
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                            slideOffsetBefore: 30,
                            slideOffsetAfter: 30,
                            noSwiping: false
                        },
                        // when window width is >= 640px
                        992: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                            slideOffsetBefore: 30,
                            slideOffsetAfter: 30,
                        },
                        // when window width is >= 640px
                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    //wrapperClass: "swiper-wrapper d-flex align-items-stretch",
                    //style: "color: red"
                }
            };
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        watch:{
            ratings(newValue, oldValue){
                localStorage.setItem('trustedShopsRatings', JSON.stringify(this.ratings));
            }
        },
        methods: {
            loadRatings(){
                axios.get("/api/third-parties/trusted-shops/all-ratings")
                    .then(result => {
                        this.ratings = result.data['quality-ranking'].shop.reviews;
                        this.disableLoader();
                        self.swiper.slideTo(3, 1000, false);
                    })
                    .catch(error => {
                        console.warn(error.message);
                    });
            },
            disableLoader(){
                this.loading = false;
            }
        },
        mounted() {
            this.loadRatings();
        },
        components: {
            swiper,
            swiperSlide
        }
    }
</script>

<style scoped type="scss">
    .swiper-slide {
        height: auto;
    }
</style>
